// @flow
export const ROOT_ROUTE = '/';
export const INNER_PAGE_ROUTE = '/:brandId';
export const GROUP_OF_BRANDS_PAGE_ROUTE = '/brands/:groupId';
export const GROUP_OF_BRANDS_INNER_PAGE_ROUTE = `${GROUP_OF_BRANDS_PAGE_ROUTE}/:brandId`;
